import { MeshDescriptions } from './MeshDescriptions.js';
export class PrimitiveBuilder {
    constructor(viewer) {
        this._viewer = viewer;
    }
    create_cube(size, options = {}) {
        var _a;
        const description = MeshDescriptions.box(size, size, size);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Cube';
        return this.create_custom_mesh(description, options);
    }
    create_box(width, height, depth, options = {}) {
        var _a;
        const description = MeshDescriptions.box(width, height, depth);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Box';
        return this.create_custom_mesh(description, options);
    }
    create_sphere(diameter, options = {}) {
        var _a;
        const description = MeshDescriptions.sphere(diameter, options.segments, options.smooth);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Sphere';
        return this.create_custom_mesh(description, options);
    }
    create_spherical_dome(diameter, cutoff, options = {}) {
        const description = MeshDescriptions.spherical_dome(diameter, cutoff, options.segments, options.smooth, options.flip);
        return this.create_custom_mesh(description, options);
    }
    create_plane(width, depth, options = {}) {
        var _a;
        const description = MeshDescriptions.plane(width, depth, options.uv0);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Plane';
        return this.create_custom_mesh(description, options);
    }
    create_torus(major_radius, minor_radius, options = {}) {
        var _a;
        const description = MeshDescriptions.torus(major_radius, minor_radius, options.major_segments, options.minor_segments, options.smooth);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Torus';
        return this.create_custom_mesh(description, options);
    }
    create_cylinder(height, radius, options = {}) {
        var _a;
        const description = MeshDescriptions.cylinder(height, radius, options.segments, options.smooth);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Cylinder';
        return this.create_custom_mesh(description, options);
    }
    create_cone(height, radius, options = {}) {
        var _a;
        const description = MeshDescriptions.cone(height, radius, options.segments, options.smooth);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Cone';
        return this.create_custom_mesh(description, options);
    }
    create_circle(radius, options = {}) {
        var _a;
        const description = MeshDescriptions.circle(radius, options.segments);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Circle';
        return this.create_custom_mesh(description, options);
    }
    create_custom_mesh(description, options) {
        var _a;
        const object_id = this._viewer.create_custom_mesh(description, options.material);
        options.name = (_a = options.name) !== null && _a !== void 0 ? _a : 'Custom Mesh';
        this._viewer.set_object_name(object_id, options.name + ' (id: ' + object_id + ')');
        return object_id;
    }
}
//# sourceMappingURL=PrimitiveBuilder.js.map